export const COLORS = {
  signatureFavn: [
    {
      name: 'Nøtt',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984969/Sigdal/Kitchens/Swatches/Sigdal-beisfarge-n%C3%B8tt.png',
    },
  ],
  amfiEik: [
    {
      name: 'Frost',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S1000-N.png',
    },
    {
      name: 'Furu',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5005-G50Y.jpg',
    },
    {
      name: 'Korn',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637075816/Sigdal/Kitchens/Swatches/S2005-Y20R.png',
    },
    {
      name: 'Hav',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-R80B.jpg',
    },
    {
      name: 'Torden',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5500-N.jpg',
    },
    {
      name: 'Høst',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-Y20R.jpg',
    },
    {
      name: 'Sky',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S2500-N.jpg',
    },
    {
      name: 'Granitt',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637164999/Sigdal/Kitchens/Swatches/NCS-S-7500-N.jpg',
    },
    {
      name: 'Frø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419164/Sigdal/Kitchens/Swatches/Sigdal-farger-5613-Y10R.jpg',
    },
    {
      name: 'Snø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
    {
      name: 'Mose',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419040/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-G80Y.jpg',
    },
    {
      name: 'Mold',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-4915-Y55R.jpg',
    },
    {
      name: 'Strøm',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419111/Sigdal/Kitchens/Swatches/Sigdal-farger-6108-B08G.jpg',
    },
    {
      name: 'Ro',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S7010-Y50R.jpg',
    },
    {
      name: 'Tundra',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-Y80R.jpg',
    },
    {
      name: 'Lakriz',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1661165981/Sigdal/Kitchens/Swatches/Lakriz.jpg',
    },
    {
      name: 'Skifer',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637072609/Sigdal/Kitchens/Swatches/Sigdal-kj%C3%B8kken_beisfarge_Skifer.png',
    },
    {
      name: 'Kongle',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637072609/Sigdal/Kitchens/Swatches/Kongle.jpg',
    },
    {
      name: 'Lin',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1661165981/Sigdal/Kitchens/Swatches/Lin.jpg',
    },
  ],

  forte: [
    {
      name: 'Snø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
  ],

  herregaard: [
    {
      name: 'Frost',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S1000-N.png',
    },
    {
      name: 'Furu',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5005-G50Y.jpg',
    },
    {
      name: 'Korn',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637075816/Sigdal/Kitchens/Swatches/S2005-Y20R.png',
    },
    {
      name: 'Hav',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-R80B.jpg',
    },
    {
      name: 'Torden',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5500-N.jpg',
    },
    {
      name: 'Høst',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-Y20R.jpg',
    },
    {
      name: 'Sky',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S2500-N.jpg',
    },
    {
      name: 'Granitt',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637164999/Sigdal/Kitchens/Swatches/NCS-S-7500-N.jpg',
    },
    {
      name: 'Frø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419164/Sigdal/Kitchens/Swatches/Sigdal-farger-5613-Y10R.jpg',
    },
    {
      name: 'Snø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
    {
      name: 'Mose',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419040/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-G80Y.jpg',
    },
    {
      name: 'Mold',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-4915-Y55R.jpg',
    },
    {
      name: 'Strøm',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419111/Sigdal/Kitchens/Swatches/Sigdal-farger-6108-B08G.jpg',
    },
    {
      name: 'Ro',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S7010-Y50R.jpg',
    },
    {
      name: 'Tundra',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-Y80R.jpg',
    },
  ],
  signaturEkbacken: [
    {
      name: 'Signatur Ekbacken brunbets',
      src:
        'Marbodal/Price%20Configurator/Colors/signatur-ekbacken-brunbets.jpg',
    },
  ],
  fagero: [
    {
      name: 'Fagerö tall',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-tall.webp',
    },
    {
      name: 'Fagerö granit',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-granit.webp',
    },
    {
      name: 'Fagerö frö',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-fro.webp',
    },
    {
      name: 'Fagerö bark',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-bark.webp',
    },
    {
      name: 'Fagerö hav',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-hav.webp',
    },
    {
      name: 'Fagerö åska',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-aska.webp',
    },
    {
      name: 'Fagerö moln',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-moln.webp',
    },
    {
      name: 'Fagerö lin',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-lin.webp',
    },
    {
      name: 'Fagerö frost',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-frost.webp',
    },
    {
      name: 'Fagerö sand',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-sand.webp',
    },
  ],
  form: [
    {
      name: 'Form åska',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-aska.webp',
    },
    {
      name: 'Form granit',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-granit.webp',
    },
    {
      name: 'Form tall',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-tall.webp',
    },
    {
      name: 'Form frö',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-fro.webp',
    },
    {
      name: 'Form bark',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-bark.webp',
    },
    {
      name: 'Form hav',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-hav.webp',
    },
    {
      name: 'Form moln',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-moln.webp',
    },
    {
      name: 'Form lin',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-lin.webp',
    },
    {
      name: 'Form frost',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-frost.webp',
    },
    {
      name: 'Form sand',
      src: 'Marbodal/Price%20Configurator/Colors/jordnara-sand.webp',
    },
  ],
  herregardEik: [
    {
      name: 'Frost',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S1000-N.png',
    },
    {
      name: 'Furu',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5005-G50Y.jpg',
    },
    {
      name: 'Korn',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637075816/Sigdal/Kitchens/Swatches/S2005-Y20R.png',
    },
    {
      name: 'Hav',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-R80B.jpg',
    },
    {
      name: 'Torden',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5500-N.jpg',
    },
    {
      name: 'Høst',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-Y20R.jpg',
    },
    {
      name: 'Sky',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S2500-N.jpg',
    },
    {
      name: 'Granitt',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637164999/Sigdal/Kitchens/Swatches/NCS-S-7500-N.jpg',
    },
    {
      name: 'Frø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419164/Sigdal/Kitchens/Swatches/Sigdal-farger-5613-Y10R.jpg',
    },
    {
      name: 'Snø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
    {
      name: 'Mose',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419040/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-G80Y.jpg',
    },
    {
      name: 'Mold',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-4915-Y55R.jpg',
    },
    {
      name: 'Strøm',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419111/Sigdal/Kitchens/Swatches/Sigdal-farger-6108-B08G.jpg',
    },
    {
      name: 'Ro',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S7010-Y50R.jpg',
    },
    {
      name: 'Tundra',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-Y80R.jpg',
    },
    {
      name: 'Lakriz',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1661165981/Sigdal/Kitchens/Swatches/Lakriz.jpg',
    },
    {
      name: 'Skifer',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637072609/Sigdal/Kitchens/Swatches/Sigdal-kj%C3%B8kken_beisfarge_Skifer.png',
    },
    {
      name: 'Kongle',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637072609/Sigdal/Kitchens/Swatches/Kongle.jpg',
    },
    {
      name: 'Lin',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1661165981/Sigdal/Kitchens/Swatches/Lin.jpg',
    },
    {
      name: 'Natur',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1661167547/Sigdal/Kitchens/Swatches/Eik_st%C3%A5ende.jpg',
    },
  ],
  horizont: [
    {
      name: 'Frost',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S1000-N.png',
    },
    {
      name: 'Furu',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5005-G50Y.jpg',
    },
    {
      name: 'Korn',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637075816/Sigdal/Kitchens/Swatches/S2005-Y20R.png',
    },
    {
      name: 'Hav',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-R80B.jpg',
    },
    {
      name: 'Torden',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5500-N.jpg',
    },
    {
      name: 'Høst',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-Y20R.jpg',
    },
    {
      name: 'Sky',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S2500-N.jpg',
    },
    {
      name: 'Granitt',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637164999/Sigdal/Kitchens/Swatches/NCS-S-7500-N.jpg',
    },
    {
      name: 'Frø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419164/Sigdal/Kitchens/Swatches/Sigdal-farger-5613-Y10R.jpg',
    },
    {
      name: 'Snø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
    {
      name: 'Mose',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419040/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-G80Y.jpg',
    },
    {
      name: 'Mold',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-4915-Y55R.jpg',
    },
    {
      name: 'Strøm',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419111/Sigdal/Kitchens/Swatches/Sigdal-farger-6108-B08G.jpg',
    },
    {
      name: 'Ro',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S7010-Y50R.jpg',
    },
    {
      name: 'Tundra',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-Y80R.jpg',
    },
  ],
  line: [
    {
      name: 'Frost',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S1000-N.png',
    },
    {
      name: 'Furu',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5005-G50Y.jpg',
    },
    {
      name: 'Korn',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637075816/Sigdal/Kitchens/Swatches/S2005-Y20R.png',
    },
    {
      name: 'Hav',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-R80B.jpg',
    },
    {
      name: 'Torden',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5500-N.jpg',
    },
    {
      name: 'Høst',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-Y20R.jpg',
    },
    {
      name: 'Sky',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S2500-N.jpg',
    },
    {
      name: 'Granitt',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637164999/Sigdal/Kitchens/Swatches/NCS-S-7500-N.jpg',
    },
    {
      name: 'Frø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419164/Sigdal/Kitchens/Swatches/Sigdal-farger-5613-Y10R.jpg',
    },
    {
      name: 'Snø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
    {
      name: 'Mose',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419040/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-G80Y.jpg',
    },
    {
      name: 'Mold',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-4915-Y55R.jpg',
    },
    {
      name: 'Strøm',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419111/Sigdal/Kitchens/Swatches/Sigdal-farger-6108-B08G.jpg',
    },
    {
      name: 'Ro',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S7010-Y50R.jpg',
    },
    {
      name: 'Tundra',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-Y80R.jpg',
    },
  ],
  sand: [
    {
      name: 'Sand',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641989602/Sigdal/Kitchens/Swatches/Sigdal-farger-S4005-Y50R.jpg',
    },
  ],
  scala: [
    {
      name: 'Frost',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S1000-N.png',
    },
    {
      name: 'Furu',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5005-G50Y.jpg',
    },
    {
      name: 'Korn',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637075816/Sigdal/Kitchens/Swatches/S2005-Y20R.png',
    },
    {
      name: 'Hav',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-R80B.jpg',
    },
    {
      name: 'Torden',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5500-N.jpg',
    },
    {
      name: 'Høst',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-Y20R.jpg',
    },
    {
      name: 'Sky',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S2500-N.jpg',
    },
    {
      name: 'Granitt',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637164999/Sigdal/Kitchens/Swatches/NCS-S-7500-N.jpg',
    },
    {
      name: 'Frø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419164/Sigdal/Kitchens/Swatches/Sigdal-farger-5613-Y10R.jpg',
    },
    {
      name: 'Snø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
    {
      name: 'Mose',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419040/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-G80Y.jpg',
    },
    {
      name: 'Mold',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-4915-Y55R.jpg',
    },
    {
      name: 'Strøm',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419111/Sigdal/Kitchens/Swatches/Sigdal-farger-6108-B08G.jpg',
    },
    {
      name: 'Ro',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S7010-Y50R.jpg',
    },
    {
      name: 'Tundra',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-Y80R.jpg',
    },
  ],
  solido: [
    {
      name: 'Hvit',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
    {
      name: 'Sort',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641995194/Sigdal/Kitchens/Swatches/Sigdal-farger-S9000-N.jpg',
    },
    {
      name: 'Grå',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641995194/Sigdal/Kitchens/Swatches/Sigdal-farger-S5502-Y.jpg',
    },
  ],
  squareEik: [
    {
      name: 'Frost',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S1000-N.png',
    },
    {
      name: 'Furu',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5005-G50Y.jpg',
    },
    {
      name: 'Korn',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637075816/Sigdal/Kitchens/Swatches/S2005-Y20R.png',
    },
    {
      name: 'Hav',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-R80B.jpg',
    },
    {
      name: 'Torden',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5500-N.jpg',
    },
    {
      name: 'Høst',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-Y20R.jpg',
    },
    {
      name: 'Sky',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S2500-N.jpg',
    },
    {
      name: 'Granitt',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637164999/Sigdal/Kitchens/Swatches/NCS-S-7500-N.jpg',
    },
    {
      name: 'Frø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419164/Sigdal/Kitchens/Swatches/Sigdal-farger-5613-Y10R.jpg',
    },
    {
      name: 'Snø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
    {
      name: 'Mose',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419040/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-G80Y.jpg',
    },
    {
      name: 'Mold',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-4915-Y55R.jpg',
    },
    {
      name: 'Strøm',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419111/Sigdal/Kitchens/Swatches/Sigdal-farger-6108-B08G.jpg',
    },
    {
      name: 'Ro',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S7010-Y50R.jpg',
    },
    {
      name: 'Tundra',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-Y80R.jpg',
    },
    {
      name: 'Lakriz',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1661165981/Sigdal/Kitchens/Swatches/Lakriz.jpg',
    },
    {
      name: 'Skifer',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637072609/Sigdal/Kitchens/Swatches/Sigdal-kj%C3%B8kken_beisfarge_Skifer.png',
    },
    {
      name: 'Kongle',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637072609/Sigdal/Kitchens/Swatches/Kongle.jpg',
    },
    {
      name: 'Lin',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1661165981/Sigdal/Kitchens/Swatches/Lin.jpg',
    },
    {
      name: 'Natur',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1661167547/Sigdal/Kitchens/Swatches/Eik_st%C3%A5ende.jpg',
    },
  ],
  uno: [
    {
      name: 'Frost',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S1000-N.png',
    },
    {
      name: 'Furu',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5005-G50Y.jpg',
    },
    {
      name: 'Korn',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637075816/Sigdal/Kitchens/Swatches/S2005-Y20R.png',
    },
    {
      name: 'Hav',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-R80B.jpg',
    },
    {
      name: 'Torden',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5500-N.jpg',
    },
    {
      name: 'Høst',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-Y20R.jpg',
    },
    {
      name: 'Sky',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S2500-N.jpg',
    },
    {
      name: 'Granitt',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637164999/Sigdal/Kitchens/Swatches/NCS-S-7500-N.jpg',
    },
    {
      name: 'Frø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419164/Sigdal/Kitchens/Swatches/Sigdal-farger-5613-Y10R.jpg',
    },
    {
      name: 'Snø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
    {
      name: 'Mose',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419040/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-G80Y.jpg',
    },
    {
      name: 'Mold',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-4915-Y55R.jpg',
    },
    {
      name: 'Strøm',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419111/Sigdal/Kitchens/Swatches/Sigdal-farger-6108-B08G.jpg',
    },
    {
      name: 'Ro',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S7010-Y50R.jpg',
    },
    {
      name: 'Tundra',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-Y80R.jpg',
    },
  ],
  vidde: [
    {
      name: 'Snø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
  ],
  fjell: [
    {
      name: 'S 5000-N',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641990260/Sigdal/Kitchens/Swatches/Sigdal-farger-S5000-N.jpg',
    },
  ],
  eikeli: [
    {
      name: 'Frost',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S1000-N.png',
    },
    {
      name: 'Furu',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5005-G50Y.jpg',
    },
    {
      name: 'Korn',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637075816/Sigdal/Kitchens/Swatches/S2005-Y20R.png',
    },
    {
      name: 'Hav',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-R80B.jpg',
    },
    {
      name: 'Torden',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S5500-N.jpg',
    },
    {
      name: 'Høst',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-Y20R.jpg',
    },
    {
      name: 'Sky',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984295/Sigdal/Kitchens/Swatches/Sigdal-farger-S2500-N.jpg',
    },
    {
      name: 'Granitt',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637164999/Sigdal/Kitchens/Swatches/NCS-S-7500-N.jpg',
    },
    {
      name: 'Frø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419164/Sigdal/Kitchens/Swatches/Sigdal-farger-5613-Y10R.jpg',
    },
    {
      name: 'Snø',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S0500-N.jpg',
    },
    {
      name: 'Mose',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419040/Sigdal/Kitchens/Swatches/Sigdal-farger-S7005-G80Y.jpg',
    },
    {
      name: 'Mold',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-4915-Y55R.jpg',
    },
    {
      name: 'Strøm',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644419111/Sigdal/Kitchens/Swatches/Sigdal-farger-6108-B08G.jpg',
    },
    {
      name: 'Ro',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984296/Sigdal/Kitchens/Swatches/Sigdal-farger-S7010-Y50R.jpg',
    },
    {
      name: 'Tundra',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1641984294/Sigdal/Kitchens/Swatches/Sigdal-farger-S8005-Y80R.jpg',
    },
    {
      name: 'Lakriz',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1661165981/Sigdal/Kitchens/Swatches/Lakriz.jpg',
    },
    {
      name: 'Skifer',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637072609/Sigdal/Kitchens/Swatches/Sigdal-kj%C3%B8kken_beisfarge_Skifer.png',
    },
    {
      name: 'Kongle',
      src:
        'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1637072609/Sigdal/Kitchens/Swatches/Kongle.jpg',
    },
  ],
}

export const RANGES = {
  forte:
    'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1642669276/Sigdal/Kitchens/Models/Forte/Sigdal_Forte-_S_0500-N.jpg',
  fjell:
    'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1640087303/Sigdal/Kitchens/Models/Fjell/Sigdal_Fjell-S5500N-hovedbilde.jpg',
  eikeli:
    'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1644246300/Sigdal/Kitchens/Models/Eikeli/Sigdal-Eikeli-Lin.jpg',
  amfiEik:
    'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1585766269/Sigdal/Kitchens/Models/Amfi%20Eik/98287_Sigdal_Amfi_Eik.jpg',
  signatureFavn:
    'Sigdal/Kitchens/Models/Signatur%20Favn/Sigdal-SignaturFavn_2-32_005.jpg',
  herregaard:
    'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1642418964/Sigdal/Kitchens/Models/Herregaard/Sigdal-Herregaard-side-S200-N.jpg',
  herregardEik:
    'Sigdal/Kitchens/Models/Herregaard%20Eik/Sigdal_Herregaard-eik.jpg',
  horizont:
    'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1652184407/Sigdal/Kitchens/Models/Horisont/Horisont_Furu-S5005-G50Y.jpg',
  line: 'Sigdal/Kitchens/Models/Line/Sigdal_Line_beige-_2.png',
  sand: 'Sigdal/Kitchens/Models/Sand/Sigdal_Sand_S4005-Y50R.png',
  scala:
    'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1659351622/Sigdal/Kitchens/Models/Scala/Fotoshoot%20Stockholm%202022/Scala-Frost-S1000N-fotoshoot_1.jpg',
  solido: 'Sigdal/Kitchens/Models/Solido/Sigdal_Solido_S9000-N.jpg',
  squareEik:
    'https://assets.nobiadigital.com/image/upload/f_auto,q_auto:eco,w_1000/v1585767198/Sigdal/Kitchens/Models/Square%20Shaker/HiRes_Sigdal_Square_Eik_Lakriz.jpg',
  tunEik: 'Sigdal/Kitchens/Models/Tun%20Eik/MK_Tun_Eik_hoved.jpg',
  uno: 'Sigdal/Kitchens/Models/Uno/Sigdal_Uno_Svanen_011.jpg',
  vidde: 'Sigdal/Kitchens/Models/Vidde/Sigdal_Vidde_S1002-Y.png',
}

export const UNITS = {
  small: 'Sigdal/Prisindikator/Units/small-blue.png',
  medium: 'Sigdal/Prisindikator/Units/medium-blue.png',
  large: 'Sigdal/Prisindikator/Units/large-blue.png',
}

export const WORKTOPS = {
  granite: 'Marbodal/Price%20Configurator/Worktops/granit.jpg',
  wood: 'Marbodal/Price%20Configurator/Worktops/ek.jpg',
  laminate: 'Marbodal/Price%20Configurator/Worktops/laminat.jpg',
  stainless: 'Marbodal/Price%20Configurator/Worktops/rostfri.jpg',
}
